import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { Tabs, Tab, Container } from '@material-ui/core'
import Header from '../../Components/Header'
import Users from './Users'
import AccessManagement from './AccessManagement'
import PageProvider, { PageContext } from '../../Context/PageProvider'

function Admin({ t }) {
    const context = useContext(PageContext)
    const user = context.user
    const classes = useStyles()
    const [value, setValue] = React.useState(0)

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`nav-tabpanel-${index}`}
                aria-labelledby={`nav-tab-${index}`}
                {...other}
            >
                {value === index && (
                    children
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `nav-tab-${index}`,
            'aria-controls': `nav-tabpanel-${index}`,
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    if (user === null) return null
    return (

        <Container maxWidth="xl" className={classes.root}>
            <Header />
            <Container maxWidth="md">
                {
                    user.isAdmin ?
                        <Fragment>
                            <Tabs
                                centered
                                value={value}
                                onChange={handleChange}
                                aria-label="Main Nav"
                                textColor="primary"
                                indicatorColor="primary"
                            >
                                <Tab label={t('users').toUpperCase()} {...a11yProps(1)} />
                                <Tab label={t('roles').toUpperCase()} {...a11yProps(0)} />
                            </Tabs>

                            <TabPanel value={value} index={0}>
                                <Users />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <AccessManagement />
                            </TabPanel>
                        </Fragment>
                        : <Users />
                }
            </Container>
        </Container>

    )
}
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        //marginTop: 48
    },
}))

export default (withTranslation()(Admin))